module.exports = __webpack_public_path__ + "static/media/t3.fb85a4f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/t3.jpg
// module id = 404
// module chunks = 0